import { render } from "./ProductSummaryCard.vue?vue&type=template&id=db4e3bc4"
import script from "./ProductSummaryCard.vue?vue&type=script&lang=js"
export * from "./ProductSummaryCard.vue?vue&type=script&lang=js"

import "./ProductSummaryCard.vue?vue&type=style&index=0&id=db4e3bc4&lang=css"

import exportComponent from "/Users/hennaqureshi/Documents/Education/3_Webdevelopment/2nd_semester_2022/Synopsis/vuex-webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__